import { render, staticRenderFns } from "./ResultsTable.vue?vue&type=template&id=614136d3"
import script from "./ResultsTable.vue?vue&type=script&lang=ts"
export * from "./ResultsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports